/**
 * @generated SignedSource<<e2af521bd81d8f384680b71fcccbed75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileLink_fileLink$data = {
  readonly date: string | null | undefined;
  readonly format: string | null | undefined;
  readonly header: string | null | undefined;
  readonly largeicon: string | null | undefined;
  readonly size: string | null | undefined;
  readonly smallicon: string | null | undefined;
  readonly text: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "FileLink_fileLink";
};
export type FileLink_fileLink$key = {
  readonly " $data"?: FileLink_fileLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileLink_fileLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallicon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeicon",
      "storageKey": null
    }
  ],
  "type": "FileLink",
  "abstractKey": null
};

(node as any).hash = "885fd3d9afab6d99bfc62cc6ea2381c3";

export default node;
